(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KEY = 'pm:recently-viewed';
    var root = document.querySelector('[data-testid="pm-recently-viewed"]');
    if (!root) return;

    // Entries are { h: handle, c: condition, b: brand }. Older builds stored bare
    // handle strings or lacked b — normalize (brand/condition show blank until re-viewed).
    function read() {
      var raw;
      try { raw = JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
      return raw
        .map(function (e) { return (typeof e === 'string') ? { h: e, c: '' } : e; })
        .filter(function (e) { return e && e.h; });
    }
    function write(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 12))); } catch (e) {}
    }

    var current = root.getAttribute('data-current-handle');
    var currentCond = root.getAttribute('data-current-condition') || '';
    var currentBrand = root.getAttribute('data-current-brand') || '';
    var currentSkip = root.getAttribute('data-current-skip') === '1';
    var excludeTypes = (root.getAttribute('data-exclude-types') || '')
      .toLowerCase().split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var list = read();

    if (current && !currentSkip) {
      list = list.filter(function (e) { return e.h !== current; });
      list.unshift({ h: current, c: currentCond, b: currentBrand });
      write(list);
    }

    var limit = parseInt(root.getAttribute('data-limit'), 10) || 4;
    var currency = root.getAttribute('data-currency') || 'GBP';
    var toShow = list.filter(function (e) { return e.h !== current; }).slice(0, limit);
    if (!toShow.length) return;

    var fmt;
    try {
      fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: currency });
    } catch (e) {
      fmt = { format: function (n) { return n.toFixed(2); } };
    }

    var grid = root.querySelector('.pm-rv__grid');

    Promise.all(
      toShow.map(function (entry) {
        return fetch('/products/' + entry.h + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            if (!p) return null;
            if (excludeTypes.indexOf((p.type || '').toLowerCase()) !== -1) return null;
            return { p: p, c: entry.c, b: entry.b };
          })
          .catch(function () { return null; });
      })
    ).then(function (items) {
      var any = false;
      items.forEach(function (item) {
        if (!item) return;
        var p = item.p;
        any = true;
        var a = document.createElement('a');
        a.className = 'pm-rv__card';
        a.href = p.url;
        a.setAttribute('role', 'listitem');

        var media = document.createElement('div');
        media.className = 'pm-rv__media';
        if (p.featured_image) {
          var img = document.createElement('img');
          img.src = p.featured_image;
          img.alt = p.title;
          img.loading = 'lazy';
          img.className = 'pm-rv__media-primary';
          media.appendChild(img);
        }
        // hover-swap: use second product image if one exists
        if (p.images && p.images.length > 1 && p.images[1] !== p.featured_image) {
          var img2 = document.createElement('img');
          img2.src = p.images[1];
          img2.alt = '';
          img2.loading = 'lazy';
          img2.className = 'pm-rv__media-alt';
          media.appendChild(img2);
        }

        var body = document.createElement('div');
        body.className = 'pm-rv__body';
        if (item.b) {
          var vendor = document.createElement('span');
          vendor.className = 'pm-rv__vendor';
          vendor.textContent = item.b;
          body.appendChild(vendor);
        }
        if (item.c) {
          var cond = document.createElement('span');
          cond.className = 'pm-rv__cond';
          cond.textContent = 'Pre-owned · ' + item.c;
          body.appendChild(cond);
        }
        var title = document.createElement('span');
        title.className = 'pm-rv__title';
        title.textContent = p.title;
        body.appendChild(title);

        var priceRow = document.createElement('div');
        priceRow.className = 'pm-rv__price-row';
        var onSale = p.compare_at_price && p.compare_at_price > p.price;
        var price = document.createElement('span');
        price.className = 'pm-rv__price' + (onSale ? ' pm-rv__price--sale' : '');
        price.textContent = fmt.format((p.price || 0) / 100);
        priceRow.appendChild(price);
        if (onSale) {
          var compare = document.createElement('span');
          compare.className = 'pm-rv__price-compare';
          compare.textContent = fmt.format(p.compare_at_price / 100);
          priceRow.appendChild(compare);
        }
        body.appendChild(priceRow);

        a.appendChild(media);
        a.appendChild(body);
        grid.appendChild(a);
      });
      if (any) root.removeAttribute('hidden');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
